export const CENTURY21_ESALES_EMAIL_TEMPLATE = {
  to: 'service.desk@century21.com.au ',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello Century21 eSales

Could you please enable Snug as an upload destination for our agency for the Century21 eSales Account(s):

- [Enter your Agency ID here]

Please assign the Century21 eSales Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
